import React, { useEffect, useState } from "react";
import TextInput from "../../../shared/TextInput";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import CustomButton from "../../../shared/CustomButton";
import DropdownField from "../../../shared/DropdownField";
import AutoCompleteField from "../../../shared/AutoCompleteField";
import { FaCheckDouble } from "react-icons/fa6";
import useFetchData from "../../../hooks/UseFetchData";
import { useTranslation } from "react-i18next";
import { RCMSpecialitiesData } from "../../../constants/SpecialityConstants";
import CheckPermission from "../../../hooks/CheckPermission";
import {
  useCreateSpecialityMutation,
  useUpdateSpecialityMutation,
} from "../../../redux/api/modules/managementApi";

function SpecialityForm({
  setOpenModal,
  selectedData,
  setSelectedData,
  payloadData,
}) {
  const { t } = useTranslation();
  const { hasPermission } = CheckPermission();
  const [createSpeciality, { isLoading: isCreating }] = useCreateSpecialityMutation();
  const [updateSpeciality, { isLoading: isUpdating }] = useUpdateSpecialityMutation();
  const isLoading = isCreating || isUpdating;
  const { executeFetch, data, loading } = useFetchData();
  const [department, setDepartment] = useState(
    selectedData?.department || null
  );

  let initialValues = {
    name_en: selectedData?.name_en || "",
    name_ar: selectedData?.name_ar || "",
    department_id: selectedData?.department?.name_en || "",
    rcm_ref: selectedData?.rcm_ref || "",
    description: selectedData?.description || "",
    intervel: selectedData?.intervel || 14,
    number_of_followup: selectedData?.number_of_followup || 1,
  };

  const validationSchema = Yup.object().shape({
    name_en: Yup.string().trim().required(" Name is required"),
    name_ar: Yup.string().trim().required(" Name is required"),
    department_id: Yup.string().required("Select department"),
    rcm_ref: Yup.number().required("RCM Reference is required"),
    intervel: Yup.number().required("Intervel is required"),
    number_of_followup: Yup.number().required("No of followup is required"),
  });

  const handleCreateNewSpeciality = async (payload) => {
    try {
      const res = await createSpeciality(payload).unwrap();
      if (res?.message) toast.success(res.message);
      setOpenModal(false);
    } catch (error) {
      toast.error(error?.data?.message || error?.message || t("Failed to create speciality"));
    }
  };

  const handleUpdateSpeciality = async (payload) => {
    payload.id = selectedData?.id;
    try {
      const res = await updateSpeciality(payload).unwrap();
      if (res?.message) toast.success(res.message);
      setOpenModal(false);
      setSelectedData(null);
    } catch (error) {
      toast.error(error?.data?.message || error?.message || t("Failed to update speciality"));
    }
  };

  const handleSubmit = (values) => {
    const action = selectedData ? "update" : "create";
    if (!hasPermission("speciality", action)) return;
    const payload = {
      ...values,
      department_id: department?.id || selectedData?.department_id,
    };
    if (selectedData) {
      handleUpdateSpeciality({ ...payload, id: selectedData.id });
    } else {
      handleCreateNewSpeciality(payload);
    }
  };

  // const fetchInitialData = async () => {
  //   await executeFetch('POST', '/v3/RCM/getSpecialities');
  // };
  // useEffect(() => {
  //   fetchInitialData();
  // }, []);

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting, values, setFieldValue }) => (
          <Form>
            <div className="grid grid-cols-2 gap-2 mt-4">
              <TextInput
                name="name_en"
                label={t("NameEN*")}
                placeholder={t("enter_name_en")}
                readOnly={!!selectedData}
              />
              <TextInput
                name="name_ar"
                label={t("NameAR*")}
                placeholder={t("enter_name_ar")}
                readOnly={!!selectedData}
              />
              <DropdownField
                label={t("speciality_rcm_ref")}
                name="rcm_ref"
                placeholder={`${t("Select")} ${t(`specialities`)}`}
                filter
                options={RCMSpecialitiesData?.map((item) => ({
                  value: item.id,
                  label: item.display,
                }))}
              />
              <AutoCompleteField
                label={t("select_department")}
                placeholder={`${t("Search")} ${t(`Department`)}`}
                queryKey="search"
                optionsFormat={(e) => {
                  return e?.map((item) => ({
                    value: item.id,
                    label: item.name_en,
                    data: item,
                  }));
                }}
                name="department_id"
                onSelect={(e) => {
                  setFieldValue("department_id", e?.value?.label);
                  setDepartment(e?.value?.data);
                }}
                fieldUrl="/v3/department/search"
                onBlur={(e) => {
                  if (!e?.target?.value || department) {
                    setFieldValue("department_id", department?.name_en);
                  }
                }}
              />
              <TextInput
                name="description"
                label={t("Description")}
                placeholder={t("Enterdescription")}
              />
              <TextInput
                name="intervel"
                type="number"
                label={t("Intervel")}
                placeholder={t("Enter Intervel")}
              />
              <TextInput
                name="number_of_followup"
                label={t("No Of Followup")}
                type="number"
                placeholder={t("Enter No Of Followup")}
              />
            </div>
            <div className=" flex items-center justify-end mt-2">
              {hasPermission("speciality", selectedData ? "update" : "create") && <CustomButton
                label={selectedData ? t("Update") : t("Submit")}
                icon={FaCheckDouble}
                loading={isLoading}
                type="submit"
                onClick={() => {
                  setOpenModal(true);
                }}
              />}
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default SpecialityForm;
